import React from 'react';
import './Modal.css';
import { formatCurrency } from '../api/currencyApi';
import { formatDate } from '../utils/dateUtils';

const PaymentsModal = ({ user, onClose, currency }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Payment History</h2>
          <button className="modal-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="modal-body">
          <div className="payment-info">
            <p className="user-info">{user.firstName} (@{user.username})</p>
          </div>

          <div className="payment-list">
            {user.payments && user.payments.length > 0 ? (
              user.payments.map(payment => (
                <div key={payment.id} className="payment-row">
                  <div className="payment-info">
                    <div className="payment-top">
                      <div className="payment-date">{formatDate(payment.date)}</div>
                      <div className="payment-status">Успешно</div>
                    </div>
                  </div>
                  <div className="payment-amount">
                    {formatCurrency(payment.amount, currency)}
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <p>Платежи не найдены</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentsModal;
